<button
  #button
  [attr.aria-label]="description() | translate"
  [class.back]="direction() === 'prev'"
  [class.next]="direction() === 'next'"
  [class.visible]="isVisible()"
  (focus)="tooltip.open = true"
  (blur)="tooltip.open = false"
>
  <span [id]="'nav-button-icon-' + direction()">
    <odl-icon [name]="icon()"></odl-icon>
  </span>
</button>
<odl-tooltip #tooltip [attr.for]="'#nav-button-icon-' + direction()">
  {{ description() | translate }}
</odl-tooltip>
